'use strict';
module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-virtualized/~/dom-helpers/util/inDOM.js
 ** module id = 3055
 ** module chunks = 0
 **/